import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { UserService } from '../../../services/UserService';
import useRequest from '../../../hooks/useRequest';

import MainLayout from '../../../components/Layouts/MainLayout';
import ListGroup from 'react-bootstrap/ListGroup';
import GradientButton from 'components/atoms/GradientButton';

import tufactura from 'assets/images/conoce-tu-factura.jpg';

import './styles.scss';

const TuFacturaView = (props) => {
    const history = useHistory();

    const {
        beforeSubmit, afterSubmit,
        dealWithError
    } = useRequest();

    const [unidadFacturacion, setUnidadFacturacion] = useState("");
    const [unidadAlternativa, setUnidadAlternativa] = useState("");
    const [alias, setAlias] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        beforeSubmit();
        const data = {
            unidadFacturacion: unidadFacturacion,
            unidadAlternativa: unidadAlternativa,
            alias: alias
        }

        UserService.vincular(data)
            .then(data => {
                afterSubmit();
                history.push('/cuenta_creada');
            }).catch((error) => {
                dealWithError(error, 'No se ha podido registrar');
            });
    }

    const consultaYDescarga = (e) => {
        e.preventDefault();

        history.push('/consulta_descarga_facturas');
    };

    return (
        <MainLayout>
            <div className="tufactura-container">
                <div className="tufactura-volver">
                    <GradientButton legend={'VOLVER'} handleClick={consultaYDescarga} />
                </div>
                <div className="tufactura-content">
                    <h1 className="tufactura-title">Cómo leer la factura</h1>
                    <div className="tufactura-columns">
                        <div className="tufactura-factura">
                            <img src={tufactura}></img>
                        </div>
                        <div className="tufactura-bullets">
                            <ListGroup>
                                <ListGroup.Item><span>1)</span> Información del destinatario postal de la factura.</ListGroup.Item>
                                <ListGroup.Item><span>2)</span> Información del propietario y dirección del inmueble que recibe el servicio.</ListGroup.Item>
                                <ListGroup.Item><span>3)</span> Nº de comprobante.</ListGroup.Item>
                                <ListGroup.Item><span>4)</span> Unidad de facturación (número que lo identifica ante la empresa).</ListGroup.Item>
                                <ListGroup.Item><span>5)</span> Nº de partido-partida inmobiliaria.</ListGroup.Item>
                                <ListGroup.Item><span>6)</span> Nº de identificación del usuario.</ListGroup.Item>
                                <ListGroup.Item><span>7)</span> Situación impositiva.</ListGroup.Item>
                                <ListGroup.Item><span>8)</span> Período comercial facturado.</ListGroup.Item>
                                <ListGroup.Item><span>9)</span> Fecha de facturación.</ListGroup.Item>
                                <ListGroup.Item><span>10)</span> Vencimiento de la próxima factura.</ListGroup.Item>
                                <ListGroup.Item><span>11)</span> Vencimiento de la factura actual.</ListGroup.Item>
                                <ListGroup.Item><span>12)</span> Monto a abonar.</ListGroup.Item>
                                <ListGroup.Item><span>13)</span> Detalle de conceptos por servicios facturados.</ListGroup.Item>
                            </ListGroup>
                        </div>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
}

export default withTranslation()(TuFacturaView);